export default function(status) {
    const titles = {
        preparing: 'Черновик на отправку',
        approving: 'Документ на согласование',
        approved: 'Согласованный документ',
        signing: 'Документ на подпись',
        signed: 'Подписанный документ',
        rework: 'Документ в доработке',
        declined: 'Отказанный документ',
    }
    return titles[status];
}
